const API_URL = process.env.REACT_APP_BACKEND_URL;

// Transform form data to a clean payload for GHL
export function buildGHLPayload(formData, tunnel) {
  return {
    // Contact
    contact_prenom: formData.prenom || "",
    contact_nom: formData.nom || "",
    contact_email: formData.email || "",
    contact_telephone: formData.telephone || "",
    contact_societe: formData.societe || "",
    contact_ville: formData.ville || "",

    // Qualification
    type_profil: tunnel,
    intention_principale: formData.intention || "",
    
    // Business
    nombre_logements: formData.logements || "",
    anciennete: formData.anciennete || "",
    ca_annuel: formData.ca_annuel || "",
    heures_semaine: formData.heures_semaine || "",
    niveau_fatigue: formData.fatigue || "",
    role_fondateur: formData.role || "",

    // Tunnel Rachat
    raison_vente: formData.raison_vente || "",
    delai_cession: formData.delai_cession || "",
    prix_souhaite: formData.prix_souhaite || "",
    nb_proprietaires: formData.nb_proprietaires || "",
    repartition_activite: Array.isArray(formData.repartition_activite) ? formData.repartition_activite.join(", ") : "",
    rentable: formData.rentable || "",
    benefice_mensuel: formData.benefice_mensuel || "",
    contrats_formalises: formData.contrats_formalises || "",
    transferable: formData.transferable || "",
    equipe: formData.equipe || "",
    nb_equipe: formData.nb_equipe || "",
    outils: Array.isArray(formData.outils) ? formData.outils.join(", ") : "",
    process_documentes: formData.process_documentes || "",
    absence_7j: formData.absence_7j || "",
    tendance_12mois: formData.tendance_12mois || "",
    elements_cession: Array.isArray(formData.elements_cession) ? formData.elements_cession.join(", ") : "",
    documents_urls: Array.isArray(formData.uploaded_files) ? formData.uploaded_files.map(f => f.url).join(", ") : "",
    commentaire: formData.commentaire_libre || "",

    // Tunnel Passif
    situation_passif: formData.situation_passif || "",
    continuer_revenu: formData.continuer_revenu || "",
    pret_sortir_operationnel: formData.pret_sortir_operationnel || "",
    implication_souhaitee: formData.implication_souhaitee || "",
    contrats_transferables_passif: formData.contrats_transferables_passif || "",
    douleur_principale: formData.douleur_principale || "",
    objectif_principal_passif: formData.objectif_principal_passif || "",
    delai_sortie: formData.delai_sortie || "",
    logements_exclure: formData.logements_exclure || "",
    logements_exclure_detail: formData.logements_exclure_detail || "",

    // Tunnel Delegation
    deleguer_priorite: Array.isArray(formData.deleguer_priorite) ? formData.deleguer_priorite.join(", ") : "",
    temps_recuperer: formData.temps_recuperer || "",
    garder_quoi: Array.isArray(formData.garder_quoi) ? formData.garder_quoi.join(", ") : "",
    croissance: formData.croissance || "",
    blocage: Array.isArray(formData.blocage) ? formData.blocage.join(", ") : "",
    utilise_pms: formData.utilise_pms || "",
    pret_methode: formData.pret_methode || "",
    type_accompagnement: formData.type_accompagnement || "",
    delai_delegation: formData.delai_delegation || "",

    // Routing incertain
    moteur_principal: formData.moteur_principal || "",
    implique_6mois: formData.implique_6mois || "",
    priorite_principale: formData.priorite_principale || "",

    // Meta
    tags: "src_siteexit",
    source_url: window.location.href,
    source_param: new URLSearchParams(window.location.search).get("source") || "",
    submitted_at: new Date().toISOString()
  };
}

// Send to backend (which stores + forwards to GHL)
export async function submitDiagnostic(formData, tunnel) {
  const payload = buildGHLPayload(formData, tunnel);
  
  const response = await fetch(`${API_URL}/api/diagnostic`, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(payload)
  });

  if (!response.ok) {
    throw new Error(`Submission failed: ${response.status}`);
  }

  return response.json();
}

// Upload a file
export async function uploadFile(file) {
  const formData = new FormData();
  formData.append("file", file);
  
  const response = await fetch(`${API_URL}/api/upload`, {
    method: "POST",
    body: formData
  });

  if (!response.ok) {
    throw new Error(`Upload failed: ${response.status}`);
  }

  return response.json();
}
